import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import * as Sentry from "@sentry/vue";

import axios from "axios";
import VueAxios from "vue-axios";

import ElementUI from "element-ui";
import { Button, Input, Form, Alert, FormItem } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import "./assets/css/inter.css";
import VueCodeHighlight from "vue-code-highlight";

import { createPinia, PiniaVuePlugin } from "pinia";

Vue.use(PiniaVuePlugin);
const pinia = createPinia();
import configService from "./services/config";

import loaderPlugin from "./plugins/loaderPlugin.js";
Vue.use(loaderPlugin, {
  store,
});

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.component(Button.name, Button);
Vue.component(Input.name, Input);
Vue.component(Form.name, Form);
Vue.component(Alert.name, Alert);
Vue.component(FormItem.name, FormItem);
Vue.use(VueAxios, axios);
Vue.use(VueCodeHighlight);

const options = {
  position: "top-right",
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: false,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: true,
  closeButton: "button",
  icon: true,
};
Vue.use(Toast, options);
async function initializeApp() {
  try {
    await configService.load();
    Vue.prototype.$config = configService;

    const DSN_URL = configService.get("dsnUrl");
    const ENVIRONMENT = configService.get("environment");

    if (DSN_URL) {
      Sentry.init({
        Vue,
        dsn: DSN_URL,
        sendDefaultPii: true,
        environment: ENVIRONMENT,
      });
    }
  } catch (error) {
    console.error("Application initialization failed:", error);
  }

  new Vue({
    router,
    store,
    vuetify,
    pinia,
    render: (h) => h(App),
  }).$mount("#app");
}

initializeApp();
